import React, { ReactElement } from "react";

export type headingLevel = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";

export type EventCardColumnHeadingProps = {
  headingLevel?: headingLevel;
  heading: string;
};

export const isEventCardColumnHeading = (
  component: React.ReactNode,
): component is ReactElement<EventCardColumnHeadingProps> => {
  if (
    !component ||
    !React.isValidElement(component) ||
    typeof component.type === "string" ||
    typeof component.type === "number" ||
    component.type.name !== EventCardColumnHeading.name
  ) {
    return false;
  }

  return true;
};

const EventCardColumnHeading = ({ heading, headingLevel = "h3" }: EventCardColumnHeadingProps) => {
  const HeadingTag = headingLevel;
  let headingClass = "cw-heading-base";

  switch (headingLevel) {
    case "h1":
      headingClass = "cw-heading-3xl";
      break;
    case "h2":
      headingClass = "cw-heading-2xl";
      break;
    case "h3":
      headingClass = "cw-heading-xl";
      break;
    case "h4":
      headingClass = "cw-heading-base";
      break;
    case "h5":
      headingClass = "cw-heading-sm";
      break;
    case "h6":
      headingClass = "cw-heading-caption";
      break;
  }

  return <HeadingTag className={`cw-m-0 cw-mr-2 ${headingClass}`}>{heading}</HeadingTag>;
};

export default EventCardColumnHeading;
